import React from 'react';
import { useLocale, usePrefixCls } from '@byte-design/config';
export function DateComparisonInput(props) {
  var value = props.value,
      placeholder = props.placeholder;
  var inputCls = usePrefixCls('compare-date-range-input');
  var singleCls = usePrefixCls('compare-date-range-input-single');
  var sourceCls = usePrefixCls('compare-date-range-input-source');
  var targetCls = usePrefixCls('compare-date-range-input-target');
  var placeholderCls = usePrefixCls('compare-date-range-input-placeholder');
  var locale = useLocale('date-comparison.compare-text');
  var source = value.source,
      isCompare = value.isCompare,
      target = value.target;

  if (isCompare && target.length) {
    return React.createElement("div", {
      className: inputCls
    }, React.createElement("div", {
      className: sourceCls
    }, source.join(' ~ ')), React.createElement("div", {
      className: targetCls
    }, locale, " ", target.join(' ~ ')));
  }

  return React.createElement("div", {
    className: inputCls
  }, React.createElement("div", {
    className: singleCls
  }, source.length ? source.join(' ~ ') : React.createElement("span", {
    className: placeholderCls
  }, placeholder)));
}